import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const PromotionsEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		code: yup.string().required().label("Code"),
		description: yup.string().nullable().label("Description"),
		discounttype: yup.string().nullable().label("Discounttype"),
		discountvalue: yup.number().nullable().label("Discountvalue"),
		minimumorderamount: yup.number().nullable().label("Minimumorderamount"),
		maximumdiscount: yup.number().nullable().label("Maximumdiscount"),
		validfrom: yup.string().required().label("Validfrom"),
		validto: yup.string().required().label("Validto"),
		usagelimit: yup.number().nullable().label("Usagelimit"),
		timesused: yup.number().nullable().label("Timesused"),
		isactive: yup.string().nullable().label("Isactive"),
		createdat: yup.string().nullable().label("Createdat")
	});
	// form default values
	const formDefaultValues = {
		code: '', 
		description: '', 
		discounttype: '', 
		discountvalue: '', 
		minimumorderamount: '', 
		maximumdiscount: '', 
		validfrom: new Date(), 
		validto: new Date(), 
		usagelimit: '', 
		timesused: "0", 
		isactive: null, 
		createdat: "(getdate())", 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/promotions`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="PromotionsEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Edit Promotion"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Code *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="code"  onChange={formik.handleChange}  value={formik.values.code}   label="Code" type="text" placeholder="Enter Code"        className={inputClassName(formik?.errors?.code)} />
                                                <ErrorMessage name="code" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Description 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="description"  onChange={formik.handleChange}  value={formik.values.description}   label="Description" type="text" placeholder="Enter Description"        className={inputClassName(formik?.errors?.description)} />
                                                <ErrorMessage name="description" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Discounttype 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="discounttype"     optionLabel="label" optionValue="value" value={formik.values.discounttype} onChange={formik.handleChange} options={app.menus.discounttype} label="Discounttype"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.discounttype)}   />
                                                <ErrorMessage name="discounttype" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Discountvalue 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="discountvalue"  onChange={formik.handleChange}  value={formik.values.discountvalue}   label="Discountvalue" type="number" placeholder="Enter Discountvalue"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.discountvalue)} />
                                                <ErrorMessage name="discountvalue" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Minimumorderamount 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="minimumorderamount"  onChange={formik.handleChange}  value={formik.values.minimumorderamount}   label="Minimumorderamount" type="number" placeholder="Enter Minimumorderamount"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.minimumorderamount)} />
                                                <ErrorMessage name="minimumorderamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Maximumdiscount 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="maximumdiscount"  onChange={formik.handleChange}  value={formik.values.maximumdiscount}   label="Maximumdiscount" type="number" placeholder="Enter Maximumdiscount"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.maximumdiscount)} />
                                                <ErrorMessage name="maximumdiscount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Validfrom *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="validfrom" showButtonBar className={inputClassName(formik?.errors?.validfrom)} dateFormat="yy-mm-dd" value={formik.values.validfrom} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="validfrom" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Validto *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="validto" showButtonBar className={inputClassName(formik?.errors?.validto)} dateFormat="yy-mm-dd" value={formik.values.validto} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="validto" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Usagelimit 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="usagelimit"  onChange={formik.handleChange}  value={formik.values.usagelimit}   label="Usagelimit" type="number" placeholder="Enter Usagelimit"  min={0}  step="any"    className={inputClassName(formik?.errors?.usagelimit)} />
                                                <ErrorMessage name="usagelimit" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Timesused 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="timesused"  onChange={formik.handleChange}  value={formik.values.timesused}   label="Timesused" type="number" placeholder="Enter Timesused"  min={0}  step="any" disabled   className={inputClassName(formik?.errors?.timesused)} />
                                                <ErrorMessage name="timesused" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Isactive 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className="field-checkbox">
                                                    <label htmlFor="isactive" className="mr-2"><strong>True</strong></label>
                                                    <InputSwitch name="isactive" checked={formik.values.isactive} trueValue="true" falseValue="false" className={inputClassName(formik?.errors?.isactive)} onChange={formik.handleChange} />
                                                    <label htmlFor="isactive" className="ml-2"><strong>False</strong></label>
                                                </div>
                                                <ErrorMessage name="isactive" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Createdat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="createdat" value={formik.values.createdat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.createdat)}        />
                                                <ErrorMessage name="createdat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label="Update" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
PromotionsEditPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'promotions',
	apiPath: 'promotions/edit',
	routeName: 'promotionsedit',
	submitButtonLabel: "Update",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Update Record",
	msgAfterSave: "Record updated successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default PromotionsEditPage;
